import http from '../../../lib/http/httpClient';
import { clearAccessToken, clearUser } from '../../../lib/auth/tokenService';
import {
  SendOtpRequest,
  SendOtpResponse,
  VerifyOtpRequest,
  LoginResponse,
  PermissionsResponse,
  MenuPermission,
} from '../types';

export const sendOtp = async (mobileNo: string): Promise<SendOtpResponse> => {
  const request = { mobile_no: mobileNo };
  const data = await http.post<SendOtpResponse>('/api/v1/cp/auth/send-otp', request, { retry: false });
  if (!data?.session_id) throw new Error('No session ID received');
  return data;
};

export const verifyOtp = async (sessionId: string, otp: string): Promise<LoginResponse> => {
  const request = { session_id: sessionId, otp };
  const data = await http.post<LoginResponse>('/api/v1/cp/auth/verify-otp', request, { retry: false });
  if (!data?.access_token) throw new Error('No access token received');
  return data;
};

export const fetchPermissions = async (): Promise<MenuPermission[]> => {
  try {
    const data = await http.get<PermissionsResponse>('/api/v1/cp/auth/permissions');
    console.log('fetchPermissions response:', data);
    console.log('fetchPermissions permissions:', data.permissions);
    return data.permissions || [];
  } catch (error) {
    console.error('Error fetching permissions:', error);
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  try { 
    await http.post('/api/v1/cp/auth/logout', null, { retry: false }); 
  } catch(error) {
    console.error('Error during logout:', error);
  } finally {
    clearAccessToken();
    clearUser();
  }
};
